import { classifyFeedFetchError } from '@/utils/request-error.js';

/** @typedef {'network' | 'server'} FeedListFetchError */

export function paginatedFeedClearListFetchError(store) {
  store.listFetchError = null;
}

/**
 * @param {object} store
 * @param {unknown} err
 * @param {{ append?: boolean }} [ctx]
 */
export function paginatedFeedApplyFetchError(store, err, { append = false } = {}) {
  if (append) return;
  if (store.rawRows.length) return;
  store.listFetchError = classifyFeedFetchError(err);
}
